import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";

import "../assets/scss/main.scss";
import "../assets/scss/overrides.scss";

import Header from "../components/Header";

class Template extends React.Component {
  render() {
    const { children } = this.props;

    return (
      <div>
        <Helmet>
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
          <link
            href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Playfair+Display:wght@500;600&display=swap"
            rel="stylesheet"
          />
        </Helmet>

        <Header />
        {children()}

        <div className="links">
          <Link to="/datenschutz">Datenschutz</Link>
        </div>
      </div>
    );
  }
}

Template.propTypes = {
  children: React.PropTypes.func
};

export default Template;



// WEBPACK FOOTER //
// ./src/layouts/index.js